import React from 'react'
import FramedIcon from 'redesign/components/atoms/FramedIcon'
import { NewsletterIcon } from 'redesign/components/atoms/Icon'
import routes from 'services/RoutesProvider/routes'
import ContentCard from '../content-card'
import { NEWSLETTER_CARD_ID, NEWSLETTER_TITLE_ID } from './constants'
import type { NewsletterCardProps } from './types'
import { useNewsletterCard } from './use-newsletter-card'

const NewsletterCard: React.FC<NewsletterCardProps> = ({ content }) => {
  const { metadata, audiences, dateText } = useNewsletterCard({ content })

  if (!metadata) return null

  return (
    <ContentCard
      dataTestId={NEWSLETTER_CARD_ID}
      header={{
        icon: <FramedIcon icon={NewsletterIcon} />,
        title: metadata.title ?? '',
        titleTestId: NEWSLETTER_TITLE_ID,
        subtitle: audiences,
        subtitleEndText: dateText,
        subtitleOverflowSingleLine: true,
      }}
      url={`${routes.cmsContentView}/${content.uuid}`}
    />
  )
}

export default NewsletterCard
